module.exports = __webpack_public_path__ + "media/country_flags/ki-07a54291.png";